export const MinMaxValidator = (value: number, min: number, max: number) => {
    if (value === undefined || value < min || value > max) return `Field must be a minimum of ${min} and a maximum of ${max}`;

    return undefined;
}

export const IntegerValidator = (value: number) => {
    return (value | 0) !== value  ? "Field must be a whole number" : undefined;
}

export const IntegerValidatorString = (value: string) => {
    const numberValue = parseFloat(value);

    return IntegerValidator(numberValue);
}
